import React, { useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { PartnerCreditService } from 'us-web-services';
import useUser from '../../store/useUser';
import DateUtil from '../../util/DateUtil';
import { Table } from '../common/Table';

function CreditTransfers() {
  const userState = useUser()[0];

  const COLUMNS = useMemo(
    () => [
      {
        id: 'creditTransfers',
        header: 'Credit Transfers',
        columns: [
          {
            header: 'Completed',
            accessorFn: rowData =>
              DateUtil.getDateSlashesString(moment(rowData.completed)),
          },
          {
            header: 'Status',
            accessorKey: 'status',
          },
          {
            header: 'Transfer Total',
            accessorFn: rowData => rowData.transferTotal,
          },
          {
            header: 'Partner',
            accessorFn: rowData => rowData.partnerName,
          },
          {
            header: 'Voucher Codes',
            accessorFn: rowData => rowData.voucherCodes || '',
          },
          {
            header: 'Transfer ID',
            accessorKey: 'id',
          },
        ],
      },
    ],
    [],
  );

  const params = () => [
    {
      key: 'userId',
      value: userState.user.id,
    },
  ];

  return (
    <Table
      columns={COLUMNS}
      retrieveData={PartnerCreditService.getTransactionsByFilter}
      params={params}
      alwaysApplyParams
      hideSearchBar
    />
  );
}

export default withRouter(CreditTransfers);
